var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-contacts-emails"},[_c('ul',[_c('li',[_c('link-with-analytics',{attrs:{"type":"email","text":"support@zavtra.co"}}),_c('span',[_vm._v("Поддержка")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }